import React, { useContext } from 'react';
import Styles from './walkthrough.module.scss'
import ReactJoyride from 'react-joyride';
import { AuthContext, ViewContext } from 'components/lib';

const CustomTooltip = ({ continuous, step, tooltipProps, primaryProps, index, backProps, skipProps, resourceId, total }) => {
  const context = useContext(AuthContext);
  const viewContext = useContext(ViewContext);

  const handleCheckboxChange = () => {
    if (!context.user.stop_walkthrough?.includes(resourceId)) {
      context.update({ stop_walkthrough: [...context?.user?.stop_walkthrough, resourceId] });
    }
  };
  return (
    <div className={Styles.mainContainer} {...tooltipProps} style={{ background: '#fff', padding: '10px' }}>
      <p className={Styles.content}>{step.content}</p>
      <button className={Styles.turnOff} onClick={handleCheckboxChange}>
        {viewContext.t('Components.Walkthrough.off')}
      </button>

      <div className={Styles.btnContainer}>
        <button className={Styles.skipBtn} {...skipProps}>
          {viewContext.t('Components.Walkthrough.skip')}
        </button>
        <span className={Styles.backAndNext}>

          {index > 0 && (
            <button style={{ color: 'black' }} {...backProps}>
              {viewContext.t('Components.Walkthrough.back')}
            </button>
          )}

          {continuous && (
            <button className={Styles.nextBtn} {...primaryProps}>
              {index < total ? viewContext.t('Components.Walkthrough.next') : viewContext.t('Components.Walkthrough.finish')}
            </button>
          )}
        </span>
      </div>
    </div>
  );
};

export function Joyride({ open, run, steps, resourceId, disableOverlay, callback }) {
  const context = useContext(AuthContext);
  return (
    !context?.user?.stop_walkthrough?.includes(resourceId) &&
    <ReactJoyride
      continuous
      disableCloseOnEsc={true}
      open={open}
      run={run}
      steps={steps}
      hideCloseButton
      scrollToFirstStep={false}
      showSkipButton
      disableOverlayClose={true}
      disableOverlay={disableOverlay}
      tooltipComponent={(props) => <CustomTooltip {...props} resourceId={resourceId} total={steps.length - 1} />}
      callback={callback ? data => { callback(data); } : null}

    />
  )
}
